import { environment } from '@quartz-iam-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('staticHtmlPageControllers')
        .factory('staticHtmlPageService', service);

    service.$inject = ['$http', '$q'];

    function service($http, $q) {

        var service = {
            getPage: getPage
        };

        var baseUrl = environment.apiUrl + '/ID/API/Page';

        return service;

        function getPage(page) {
            return $http
                .get(baseUrl + '/' + page, {})
                .then(function (response) {
                    return response.data;
                });
        }
    }
})();
